import React, { useEffect } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import GridItem from '../../Grid/GridItem.js';
import { connect } from 'react-redux';
import GridContainer from '../../Grid/GridContainer.js';
import Button from '../../CustomButtons/Button.js';
import Card from '../../Card/Card.js';
import { NavLink } from 'react-router-dom';
import LocalGroceryStore from '@material-ui/icons/LocalGroceryStore';
import Edit from '@material-ui/icons/Edit';
import LockOpen from '@material-ui/icons/LockOpen';
import UserUpdate from './UserUpdate';
import ChangePassword from './ChangePassword';
import UserDetails from './UserDetails';
import Dashboard from './Orders';

import Header from '../Header/Header';
import FormatListNumbered from '@material-ui/icons/FormatListNumbered';
import CardAvatar from '../../Card/CardAvatar.js';
import CardBody from '../../Card/CardBody.js';
import { getUserDetails as getUserList } from '../../../store/actions/user/User';
import { Route, Switch } from 'react-router-dom';
import Orders from '../../User/Orders';
import Footer from '../Footer/Footer';

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

var update = false;
function UserDashboard(props) {
  useEffect(() => {
    props.getUserList();
  }, [update]);
  const classes = useStyles();

  return (
    <div className="App">
      <Header />
      <div className="container-fluid profile">
        <br />
        <br />
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <Card profile>
              <CardAvatar profile style={{ transform: 'translateY(25px)' }}>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <img
                    src="https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/10_avatar-256.png"
                    style={{ width: '90px', height: '90px' }}
                    alt="..."
                  />
                </a>
              </CardAvatar>
              <CardBody profile style={{ transform: 'translateY(10px)' }}>
                <h5 className={classes.cardTitle}>
                  {props.userDetails !== undefined ? (
                    <>
                      {props.userDetails.lastName} {props.userDetails.firstName}
                      <p className={classes.cardCategory}>
                        {props.userDetails.emailId}
                      </p>
                      <br />
                    </>
                  ) : (
                    <>
                      <img
                        src="https://inolemit.sirv.com/utils/35%20(1).gif"
                        style={{ width: '30px', height: '30px' }}
                        alt=""
                      />{' '}
                      <br />{' '}
                    </>
                  )}{' '}
                </h5>
                <p className={classes.description}>
                  <NavLink
                    exact
                    activeClassName="try-active navbar__link_active"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                    className="navbar__link"
                    to="/user/orders"
                  >
                    <LocalGroceryStore
                      style={{ fontSize: '17px', textDecoration: 'none' }}
                    />{' '}
                    <span
                      style={{
                        textAlign: 'left',
                        textDecoration: 'none',
                        color: 'inherit',
                        marginRight: '28px',
                        paddingLeft: '15px'
                      }}
                    >
                      My orders{' '}
                    </span>{' '}
                  </NavLink>
                </p>
                <p className={classes.description}>
                  <NavLink
                    exact
                    activeClassName="try-active navbar__link_active"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                    className="navbar__link"
                    to="/user/details"
                  >
                    <FormatListNumbered
                      style={{ fontSize: '17px', textDecoration: 'none' }}
                    />{' '}
                    <span
                      style={{
                        textAlign: 'left',
                        textDecoration: 'none',
                        marginRight: '28px',
                        paddingLeft: '15px'
                      }}
                    >
                      My details
                    </span>
                  </NavLink>
                </p>
                <p className={classes.description}>
                  <NavLink
                    exact
                    activeClassName="try-active navbar__link_active"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                    className="navbar__link"
                    to="/user/changePassword"
                  >
                    <LockOpen style={{ fontSize: '17px' }} /> Change password
                  </NavLink>
                </p>
                <Button style={{ background: '#34BA92' }} round>
                  <NavLink
                    exact
                    activeClassName="try-active navbar__link_active"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                    className="navbar__link"
                    to="/user/update"
                  >
                    <Edit /> Update profile
                  </NavLink>
                </Button>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={9}>
            <Switch>
              <Route exact path="/user" component={Dashboard} />
              <Route path="/user/update" component={UserUpdate} />
              <Route path="/user/details" component={UserDetails} />
              <Route path="/user/orders" component={Orders} />
              <Route path="/user/changePassword" component={ChangePassword} />
            </Switch>
          </GridItem>
        </GridContainer>
      </div>
      <Footer />
    </div>
  );
}

const mapStateWithProps = (state) => ({
  userDetails: state.user.userDetails
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getUserList: () => dispatch(getUserList())
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(UserDashboard);
